import React from "react";
import { Award, Trophy, Medal, BookOpen } from "lucide-react";
import "../styles/Achievements.css";

const categories = [
  {
    title: "Technical Certifications",
    icon: <BookOpen size={20} />,
    items: [
      { name: "Programming in Modern C++", issuer: "NPTEL" },
      { name: "Understanding Incubation & Entrepreneurship", issuer: "NPTEL" },
      { name: "Google Cloud Computing Foundations", issuer: "Qwiklabs" },
      { name: "AIML Honors Track", issuer: "Academic" },
    ],
  },
  {
    title: "Competition Achievements",
    icon: <Trophy size={20} />,
    items: [
      { name: "Winners – Goa Police Hackathon 2025", issuer: "State Level" },
      { name: "1st Place – Internship Project, Lenovo LEAP", issuer: "Program Achievement" },
      { name: "Finalist – Smart India Hackathon (SIH) 2024", issuer: "National Level" },
      { name: "Finalist – IDEAS 2025 & 2026", issuer: "PCCE" },
      { name: "Top 10 – Converge 3.0 Innovative Idea Challenge", issuer: "Competition" },
    ],
  },
  {
    title: "Sports Achievements",
    icon: <Medal size={20} />,
    items: [
      { name: "1st Place – 800m Relay", issuer: "Inter-College" },
      { name: "3rd Place – 200m Sprint", issuer: "Inter-College" },
    ],
  },
];

const Achievements = () => {
  return (
    <section className="achievements">
      <div className="achievements-header">
        <p className="achievements-label">Recognition</p>
        <h2>Certifications & Achievements</h2>
        <p className="achievements-subtitle">
          Certifications, hackathon wins, and athletic achievements that showcase a well-rounded profile.
        </p>
      </div>

      <div className="achievements-grid">
        {categories.map((cat, index) => (
          <div className="achievement-category-card" key={index}>
            <div className="achievement-category-header">
              <span className="achievement-icon">{cat.icon}</span>
              <h3>{cat.title}</h3>
            </div>
            <ul>
              {cat.items.map((item, idx) => (
                <li key={idx}>
                  <div className="achievement-item">
                    <Award size={14} className="achievement-bullet" />
                    <div>
                      <span className="achievement-name">{item.name}</span>
                      <span className="achievement-issuer">{item.issuer}</span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="achievements-stats">
        <div className="stat-card">
          <span className="stat-number">4</span>
          <span className="stat-label">Certifications</span>
        </div>
        <div className="stat-card">
          <span className="stat-number">5</span>
          <span className="stat-label">Competitions</span>
        </div>
        <div className="stat-card">
          <span className="stat-number">2</span>
          <span className="stat-label">Sports Medals</span>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
